import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { useAuth } from "../../context/AuthProvider";
import AddExpense from "../pages/expense/AddExpense";
import uRLs from "../../utils/baseUtils";
import QuickRecharge from "../pages/recharge/QuickRecharge";
import { Tooltip } from "@mui/material";
import { usePermission } from "../../context/PermissionContext";
import GetServerLiveTime from "../../constants/GetServerLiveTime";
import DateConverter from "@heartinz/date_and_time_processor";
import AddJobcard from "../pages/jobcard/AddJobcard";
import EditJobcard from "../pages/jobcard/Editjobcard";
import AxiosInstance from "../../utils/AxiosInstance";
import { useNetwork } from "../../context/NetworkContext";
import { useShowAlert } from "../../context/AlertContext";
import handleError from "../../constants/handleError";
import { createPortal } from "react-dom";
import packageJson from "@/../../package.json";
import UpdateConfirmationModal from "../../constants/updatexConfirmation";
import {
  CogIcon,
  LogOutIcon,
  MenuIcon,
  StoreIcon,
  UserIcon,
} from "../../constants/Icons";
import SubscriptionModal from "../../constants/SubscriptionModal";
function Header({ toggleSideMenu, isSideMenuOpen, isActive }) {
  const { isUser, isLoading, handleLogout, settings } = useAuth();
  const {
    permission,
    hasModulePermission,
    activeStoreModules,
    blockedPermissions,
    setGlobelPopupOpen,
  } = usePermission();
  const { isOnline } = useNetwork();
  const [networkMessage, setNetworkMessage] = useState("");
  const [showBanner, setShowBanner] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isHoveringRecharge, setIsHoveringRecharge] = React.useState(false);
  const [isHoveringExpense, setIsHoveringExpense] = React.useState(false);
  const [isHoveringJobCard, setIsHoveringJobCard] = React.useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const isFirstRender = useRef(true);

  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  const [taskTitleSuggest, setTaskTitleSuggest] = useState([]);
  const [estimateSuggest, setEstimateSuggest] = useState([]);
  const [attributesTitleSuggest, setAttributesTitleSuggest] = useState([]);
  const hasFetched = useRef(false);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [activeModal, setActiveModal] = useState(null);
  const serverTime = GetServerLiveTime();
  const iso = serverTime.toISOString();
  const currentDate = DateConverter.convertToTimeZone(iso, isUser?.timezone);
  const openModal = (name) => {
    if (name === "jobcard") {
      setEditData(null);
    }

    setActiveModal(name);
    setGlobelPopupOpen(true);
  };
  const closeModal = () => {
    setActiveModal(null);
    setGlobelPopupOpen(false);
  };

  const subscriptionExpiresIn = settings?.mainStoreDetails?.expiresIn;

  const isSubscriptionExpiringSoon = (() => {
    if (!subscriptionExpiresIn) return false;

    try {
      if (
        new Date(subscriptionExpiresIn).getTime() <= new Date(iso).getTime()
      ) {
        return false;
      }

      const difference = DateConverter.getTimeDifference(
        iso,
        subscriptionExpiresIn,
      );

      return difference.days <= 30;
    } catch (error) {
      console.error("Subscription expiry calculation failed:", error);
      return false;
    }
  })();

  const handleFieldUpdate = async (jobcardId, field, value) => {
    try {
      if (!checkNetwork()) return;
      const payload = new FormData();
      if (field === "mediaFile" && value instanceof File) {
        payload.append("media", value);
      } else if (field === "attributes" && Array.isArray(value)) {
        payload.append(field, JSON.stringify(value));
      } else if (field === "customerid" && value?._id) {
        payload.append("customerid", value._id);
      } else {
        payload.append(field, value ?? "");
      }
      const res = await AxiosInstance.patch(
        `/module/jobcard/${jobcardId}`,
        payload,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      const updatedJobcard = res.data.results;
      showAlert("success", `${field} updated successfully`);
      setEditData(updatedJobcard);
      return updatedJobcard;
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleTaskSuggestion = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/jobcard/suggestion/task/title`,
      );
      setTaskTitleSuggest(response.data.results || []);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleAttributesSuggestion = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/jobcard/suggestion/attributes`,
      );
      setAttributesTitleSuggest(response.data.results || []);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSuggestEstimate = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/jobcard/type`);

      setEstimateSuggest(response.data.results || []);
      // setShowtitlePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const intervalMs = (uRLs.UPDATE_CHECK_INTERVAL || 20) * 60 * 1000;
    const now = new Date(serverTime).getTime();
    let timer = null;
    let remainingMs = intervalMs;
    let lastStartTime = null;

    const check = async () => {
      try {
        const registration = await navigator.serviceWorker.ready;

        registration.active?.postMessage({
          type: "CHECK_UPDATE",
        });
      } catch (error) {
        console.error("Service worker check failed:", error);
      }
    };

    const startTimer = () => {
      // Don't run anything while tab is hidden
      if (document.hidden || timer) return;

      lastStartTime = new Date(serverTime).getTime();

      timer = setTimeout(async () => {
        timer = null;
        remainingMs = intervalMs;

        await check();

        // Only continue if tab is still visible
        if (!document.hidden) {
          startTimer();
        }
      }, remainingMs);
    };

    const pauseTimer = () => {
      if (!timer) return;

      const elapsed = new Date(serverTime).getTime() - lastStartTime;

      remainingMs = Math.max(remainingMs - elapsed, 0);

      clearTimeout(timer);
      timer = null;
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Pause timer
        pauseTimer();
      } else {
        // Continue from remaining time
        startTimer();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Start only when tab is visible
    if (!document.hidden) {
      startTimer();
    }

    return () => {
      clearTimeout(timer);

      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (!navigator.serviceWorker) return;

    const handler = (event) => {
      if (event.data?.type === "UPDATE_AVAILABLE") {
        setUpdateAvailable(true);
      }
    };

    navigator.serviceWorker.addEventListener("message", handler);

    return () =>
      navigator.serviceWorker.removeEventListener("message", handler);
  }, []);

  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        navigator.serviceWorker.ready.then((registration) => {
          registration.active?.postMessage({
            type: "CHECK_UPDATE",
          });
        });
      }
    };

    document.addEventListener("visibilitychange", onVisible);

    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    if (
      activeStoreModules("JOBCARD") &&
      (hasModulePermission("JOBCARD") || permission === undefined)
    ) {
      handleSuggestEstimate();
      handleTaskSuggestion();
      handleAttributesSuggestion();
    }
  }, []);

  const handleReload = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();

      if ("caches" in window) {
        caches.keys().then((names) => {
          for (let name of names) caches.delete(name);
        });
      }

      window.location.href = window.location.pathname;
    } catch (e) {
      console.error("Cache clear failed", e);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Don't show any banner on page load
    }

    if (!isOnline) {
      setNetworkMessage("No Connection");
      setShowBanner(true);
    } else {
      setNetworkMessage("Back online");
      setShowBanner(true);

      const timer = setTimeout(() => {
        setShowBanner(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOnline]);
  const removeModalBackdrop = () => {
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.style.display = "none";
    }
  };
  return (
    <header className="header-top">
      <div
        className={`topbar d-flex align-items-center ${isSideMenuOpen ? "z-low" : "z-high"}`}
      >
        <nav className="navbar navbar-expand gap-3">
          <div
            className="topbar-logo-header d-none d-lg-flex"
            onClick={() => {
              toggleSideMenu();
              removeModalBackdrop();
            }}
          >
            <img
              src="/assets/images/logo-white.png"
              className="logo-icon"
              alt="Logo"
            />
          </div>

          <div
            className="mobile-toggle-menu"
            onClick={() => {
              toggleSideMenu();
              removeModalBackdrop();
            }}
          >
            <MenuIcon />
          </div>

          <div className="top-menu ms-auto"></div>

          {/* Subscription Expiry Banner */}
          {isSubscriptionExpiringSoon && (
            <button
              type="button"
              className="badge bg-warning text-dark fw-bold text-nowrap border-0 "
              onClick={() => setShowSubscriptionModal(true)}
              style={{ cursor: "pointer" }}
            >
              Subscription expiring soon
            </button>
          )}

          {uRLs.JOBCARD === "true" &&
            activeStoreModules("JOBCARD") &&
            (hasModulePermission("JOBCARD") || permission === undefined) && (
              <div
                className={`${
                  isHoveringJobCard ? "mobile-toggle-menu" : "head-icon"
                }`}
                onMouseEnter={() => setIsHoveringJobCard(true)}
                onMouseLeave={() => setIsHoveringJobCard(false)}
              >
                <Tooltip title="Add JobCard" arrow>
                  <i
                    className="bx bx-id-card text-white"
                    onClick={() => openModal("jobcard")}
                  ></i>
                </Tooltip>
              </div>
            )}

          {uRLs.RECHARGE_MODULE === "true" &&
            activeStoreModules("RECHARGE") &&
            (hasModulePermission("RECHARGE") || permission === undefined) && (
              <div
                className={`${
                  isHoveringRecharge ? "mobile-toggle-menu" : "head-icon"
                }`}
                onMouseEnter={() => setIsHoveringRecharge(true)}
                onMouseLeave={() => setIsHoveringRecharge(false)}
              >
                <Tooltip title="Add Recharge" arrow>
                  <i
                    className="bx bx-dollar-circle text-white"
                    onClick={() => openModal("recharge")}
                  ></i>
                </Tooltip>
              </div>
            )}

          {uRLs.EXPENSE_MODULE === "true" &&
            (hasModulePermission("EXPENSE") || permission === undefined) && (
              <div
                className={`${
                  isHoveringExpense ? "mobile-toggle-menu" : "head-icon"
                }`}
                onMouseEnter={() => setIsHoveringExpense(true)}
                onMouseLeave={() => setIsHoveringExpense(false)}
              >
                <Tooltip title="Add Expense" arrow>
                  <i
                    className="ng ng-ng-expence-add-icon text-white"
                    onClick={() => openModal("expense")}
                  ></i>
                </Tooltip>
              </div>
            )}
          <div className="user-box dropdown px-3">
            <div className="dropdown">
              {permission === undefined && (
                <Link
                  to="#"
                  className="d-flex align-items-center nav-link dropdown-toggle gap-2 dropdown-toggle-nocaret "
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ position: "relative" }}
                >
                  {updateAvailable && (
                    <span className="status-badge update"></span>
                  )}

                  {/* {updateAvailable && (
                    <span className="update-badge">
                      <i className="bx bxs-circle"></i>
                    </span>
                  )} */}

                  <img
                    src={
                      settings?.saleProfileData?.image
                        ? uRLs.IMAGE_URL +
                          "profile/" +
                          settings?.saleProfileData?.image
                        : "/assets/images/avatars/businessIcon.png"
                    }
                    alt="Business Icon"
                    className="user-img rounded-circle"
                    style={{ background: "white", objectFit: "contain" }}
                  />
                  <div className="d-flex flex-column ms-2">
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-semibold text-white">
                        {isLoading ? <Skeleton width={120} /> : isUser?.title}
                      </span>

                      {/* {updateAvailable && (
                        <span className="badge bg-warning text-dark fw-bold">
                          Update Available
                        </span>
                      )} */}
                    </div>
                    <span className="text-white fs-7">
                      {isLoading ? <Skeleton width={120} /> : isUser?.stype}
                    </span>
                  </div>
                </Link>
              )}
              {permission !== undefined && (
                <Link
                  to="#"
                  className="d-flex align-items-center nav-link dropdown-toggle gap-2 dropdown-toggle-nocaret"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ position: "relative" }}
                >
                  <span
                    className={`status-badge ${isOnline ? "online" : "offline"}`}
                  ></span>
                  <img
                    src={
                      settings?.saleProfileData?.image
                        ? uRLs.IMAGE_URL +
                          "profile/" +
                          settings?.saleProfileData?.image
                        : "/assets/images/avatars/businessIcon.png"
                    }
                    alt="Business Icon"
                    className="user-img rounded-circle"
                    style={{ background: "white", objectFit: "contain" }}
                  />
                  <div className="d-flex flex-column ms-2">
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-semibold text-white">
                        {isLoading ? <Skeleton width={120} /> : isUser?.title}
                      </span>

                      {/* {updateAvailable && (
                        <span className="badge bg-warning text-dark fw-bold">
                          Update Available
                        </span>
                      )} */}
                    </div>
                    <span className="text-white fs-7">
                      {isLoading ? <Skeleton width={120} /> : isUser?.stype}
                    </span>
                  </div>
                </Link>
              )}
              <ul className="dropdown-menu dropdown-menu-end shadow-lg">
                {permission === undefined && (
                  <li>
                    <Link className="dropdown-item" to="/profile">
                      <div className="d-flex align-items-start">
                        <UserIcon iClass={"me-2 mt-1"} />
                        <div className="user-info">
                          <div className="">
                            {" "}
                            {isLoading ? (
                              <Skeleton width={200} />
                            ) : (
                              isUser?.title
                            )}
                          </div>
                          <div className="fs-7">
                            {isLoading ? (
                              <Skeleton width={200} />
                            ) : (
                              isUser?.email
                            )}
                          </div>
                          <div className="text-lowercase fs-7">
                            {isLoading ? (
                              <Skeleton width={200} />
                            ) : (
                              isUser?.stype
                            )}
                          </div>
                        </div>
                      </div>
                    </Link>
                  </li>
                )}
                {permission !== undefined && (
                  <li>
                    <div className="dropdown-item">
                      <div className="d-flex align-items-start">
                        <UserIcon iClass={"me-2 mt-1"} />
                        <div className="user-info">
                          <div className="">
                            {" "}
                            {isLoading ? (
                              <Skeleton width={200} />
                            ) : (
                              isUser?.staffInfo?.userName
                            )}
                          </div>
                          <div className="text-lowercase fs-7">
                            {isLoading ? (
                              <Skeleton width={200} />
                            ) : (
                              isUser?.stype
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                )}
                <li>
                  <hr className="dropdown-divider" />
                </li>

                {uRLs.MANAGEOUTLET_MODULE === "true" &&
                  isUser?.stype === "MAIN" &&
                  (hasModulePermission("OUTLET") ||
                    permission === undefined) && (
                    <li>
                      <Link className="dropdown-item" to="/store">
                        <StoreIcon /> Manage Outlet
                      </Link>
                    </li>
                  )}
                <Link
                  className="dropdown-item"
                  onClick={() => {
                    if (updateAvailable) {
                      setShowUpdateModal(true);
                    } else {
                      handleReload();
                    }
                  }}
                >
                  <i
                    className={`bx ${
                      updateAvailable ? "bx-cloud-download" : "bx-reset"
                    }`}
                  ></i>

                  {updateAvailable ? " Update" : "Refresh"}

                  {updateAvailable && (
                    <span className="badge bg-danger ms-2">New</span>
                  )}
                </Link>
                {(hasModulePermission("SETTINGS") ||
                  permission === undefined) && (
                  <li>
                    <Link className="dropdown-item" to="/setting">
                      <CogIcon /> Settings
                    </Link>
                  </li>
                )}
                {/* {isUser?.stype === "MAIN" && (
                  <li>
                    <Link className="dropdown-item" to="/account-deletion">
                      <i className="bx bx-trash"></i> Account Deletion 
                    </Link>
                  </li>
                )} */}
                <li>
                  <hr className="dropdown-divider" />
                </li>

                {/* logout btn change to profile page part */}
                {permission !== undefined && (
                  <>
                    <li>
                      <button className="dropdown-item" onClick={handleLogout}>
                        <LogOutIcon /> Logout
                      </button>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                  </>
                )}
                {/* <h1>hi</h1> */}
                <div className="text-end me-2">
                  <span className="font-11">V_</span>
                  <span className="font-11">{packageJson.version}</span>
                </div>
              </ul>
            </div>
          </div>
        </nav>
        {/* {activeModal === 'jobcard' && createPortal(
          <AddJobcard
            isOpen={true}
            onClose={closeModal}
            setEditData={setEditData}
            estimateSuggest={estimateSuggest}
            setEditModalOpen={setEditModalOpen}
            titleSuggest={taskTitleSuggest}
          />,
  document.body
        )} */}

        {/* Subscription Expiry Banner */}

        {activeModal === "jobcard" &&
          createPortal(
            <EditJobcard
              isOpen={true}
              isActive={isActive}
              editData={editData}
              onClose={closeModal}
              onFieldUpdate={handleFieldUpdate}
              titleSuggest={taskTitleSuggest}
              attributeSuggest={attributesTitleSuggest}
              jobcardTitleSuggest={estimateSuggest}
              setTitleSuggest={setEstimateSuggest}
            />,
            document.body,
          )}

        {activeModal === "expense" &&
          createPortal(
            <AddExpense
              isOpen={true}
              isActive={true}
              onClose={closeModal}
              expenseDate={currentDate}
            />,
            document.body,
          )}

        {activeModal === "recharge" &&
          createPortal(
            <QuickRecharge isOpen={true} onClose={closeModal} />,
            document.body,
          )}

        {showBanner && (
          <div className={`network-banner ${isOnline ? "online" : "offline"}`}>
            <span className="dot" />
            {networkMessage}
          </div>
        )}
      </div>
      <UpdateConfirmationModal
        isOpen={showUpdateModal}
        onClose={() => setShowUpdateModal(false)}
        onConfirm={() => {
          setShowUpdateModal(false);
          handleReload();
        }}
      />

      <SubscriptionModal
        isOpen={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
        expiryDate={subscriptionExpiresIn}
      />
    </header>
  );
}

export default Header;
